import { buildFyTickFormatter } from '~/components/Charts/fyTickFormatter'
import { partialFyLabels } from '~/components/Charts/partialFyLabels'
import { GRANULARITY } from '~/components/Charts/chrome/chartChrome'

/** FY v2 (spec §4.4): post-flatten FY treatment for sheets. Time column carries the chart's
 *  label (FY xx/yy, `*` on partial buckets — same builder as every chart surface, T6b
 *  anti-drift); Bucket start keeps the machine-sortable ISO. windowFor resolves the bounds the
 *  row's walk was fired with (per-arm on multi pins — each arm's own window decides its own
 *  marker, mirroring fyNoteLabelsForRow). */
export function applyFyTimeColumns(
  table: { columns: string[]; rows: Array<Record<string, unknown>> },
  windowFor: (row: Record<string, unknown>) => { from: string; to: string },
): { columns: string[]; rows: Array<Record<string, unknown>> } {
  const timeIdx = table.columns.indexOf('Time')
  if (timeIdx === -1) return table
  const columns = [...table.columns]
  columns.splice(timeIdx + 1, 0, 'Bucket start')
  const fmtCache = new Map<string, (v: string | number) => string>()
  const rows = table.rows.map((r) => {
    const t = r.Time
    if (t == null) return { ...r, 'Bucket start': null }
    const w = windowFor(r)
    const key = `${w.from}\0${w.to}`
    let fmt = fmtCache.get(key)
    if (!fmt) {
      fmt = buildFyTickFormatter(w.from, w.to)
      fmtCache.set(key, fmt)
    }
    return { ...r, Time: fmt(String(t)), 'Bucket start': t }
  })
  return { columns, rows }
}

/** Deduped union of each window's partial fiscal years through the shared draft copy.
 *  Null when nothing is partial (no note row). Same union rule as fyNoteLabelsForRow. */
export function exportPartialFyNote(windows: Array<{ from: string; to: string }>): string | null {
  const labels: string[] = []
  for (const w of windows) {
    for (const label of partialFyLabels(w.from, w.to)) {
      if (!labels.includes(label)) labels.push(label)
    }
  }
  return labels.length > 0 ? GRANULARITY.partialFyNote(labels) : null
}
